/* eslint-disable no-use-before-define */
import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function AutocompleteInput(props) {
  const { list, name, setSelectedOption, index, selectedVal } = props;
  const forwardIndex = (event, value) => {
    setSelectedOption(event, value, index);
  };
  return (
    <Autocomplete
      onChange={forwardIndex}
      id={`combo-box-${name}`}
      options={list}
      getOptionSelected={(option, value) => option === value.name}
      getOptionLabel={(option) => option.name}
      value={selectedVal ? selectedVal : ""}
      // style={{ width: 300 }}
      renderInput={(params) => (
        <TextField {...params} margin="dense" variant="outlined" />
      )}
    />
  );
}
